<template>
  <div v-if="test">
    <CCard>
      <CCardHeader>
        <strong>Редактирование A/B теста: {{ test.name }}</strong>
      </CCardHeader>
      <CCardBody>
        <CForm @submit.prevent="updateTest">
          <CRow>
            <CCol md="6">
              <CInput
                label="Название теста"
                v-model="test.name"
                :invalid="!!errors.name"
                :feedback="errors.name"
                required
              />
            </CCol>
            <CCol md="6">
              <CInput
                label="Ключ теста"
                v-model="test.key"
                :invalid="!!errors.key"
                :feedback="errors.key"
                description="Уникальный ключ для использования в коде приложения"
                required
              />
            </CCol>
          </CRow>
          
          <CRow>
            <CCol md="12">
              <CTextarea
                label="Описание"
                v-model="test.description"
                rows="3"
                :invalid="!!errors.description"
                :feedback="errors.description"
              />
            </CCol>
          </CRow>
          
          <CRow>
            <CCol md="6">
              <CInput
                label="Процент трафика"
                v-model.number="test.traffic_allocation"
                type="number"
                min="1"
                max="100"
                :invalid="!!errors.traffic_allocation"
                :feedback="errors.traffic_allocation"
                description="Процент пользователей, участвующих в тесте (1-100%)"
                required
              />
            </CCol>
            <CCol md="6">
              <div class="form-group">
                <label class="form-label">
                  <input 
                    type="checkbox" 
                    v-model="test.active"
                    class="mr-2"
                  />
                  Активный тест
                </label>
                <div class="small text-muted">
                  Активный: {{ test.active ? 'Да' : 'Нет' }}
                </div>
              </div>
            </CCol>
          </CRow>
          
          <hr>
          
          <div class="d-flex justify-content-between">
            <CButton
              color="secondary"
              variant="outline"
              @click="$router.push(`/ab-tests/${test.id}`)"
            >
              Отмена
            </CButton>
            <CButton
              color="primary"
              type="submit"
              :disabled="loading"
            >
              <CSpinner v-if="loading" size="sm" class="mr-1" />
              {{ loading ? 'Сохранение...' : 'Сохранить' }}
            </CButton>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  name: 'AbTestEdit',
  data() {
    return {
      test: null,
      loading: false,
      errors: {}
    }
  },
  async mounted() {
    await this.fetchTest()
  },
  methods: {
    async fetchTest() {
      try {
        const { data } = await this.$http.get(`/ab-tests/${this.$route.params.id}`)
        this.test = data
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка загрузки теста')
        console.error(error)
        this.$router.push({
          path: '/ab-tests'
        })
      }
    },
    
    async updateTest() {
      this.loading = true
      this.errors = {}
      
      try {
        // Валидация
        if (!this.test.name) {
          this.errors.name = 'Название обязательно'
        }
        if (!this.test.key) {
          this.errors.key = 'Ключ обязателен'
        }
        
        if (Object.keys(this.errors).length > 0) {
          return
        }
        
        const { data } = await this.$http.put(`/ab-tests/${this.test.id}`, {
          name: this.test.name,
          key: this.test.key,
          description: this.test.description,
          traffic_allocation: this.test.traffic_allocation,
          active: this.test.active
        })
        
        this.$root.$emit('showSuccess', 'A/B тест успешно обновлен')
        this.$router.push({
          path: '/ab-tests/' + data.id
        })
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.$root.$emit('showError', error.response.data.message)
        } else {
          this.$root.$emit('showError', 'Ошибка обновления теста')
        }
        console.error(error)
      }
      
      this.loading = false
    }
  }
}
</script> 